import Pusher from 'pusher-js';

const PUSHER_KEY = import.meta.env.VITE_PUSHER_APP_KEY || 'app-key';
const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1';

// Skip initialization if we don't have a real key configured to avoid console errors
const isMockKey = PUSHER_KEY === 'your-pusher-key' || PUSHER_KEY === 'app-key';

export const pusher = isMockKey 
  ? {
      subscribe: () => ({ 
        bind: () => {}, 
        unbind: () => {} 
      }),
      unsubscribe: () => {},
      bind_global: () => {},
      unbind_global: () => {},
      disconnect: () => {}
    } as any 
  : new Pusher(PUSHER_KEY, {
      cluster: PUSHER_CLUSTER,
      forceTLS: true
    });

export const socket = pusher;
export default pusher;
